import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from '../../../../img/icons/svg/botones/flecha-big-gris.svg'
import useGetSolicitudGastosContingenciaProfesionalItByID from 'services/record/SolicitudGastosContingenciaProfesional/useGetSolicitudGastosContingenciaProfesionalItByID'
import Loader from 'components/blocks/Loader/Loader'
import SolicitudGastosContingenciaProfesional from './SolicitudGastosContingenciaProfesional'
import useDecode from 'hooks/useDecode'

export enum TipoGastoEnum {
  Transporte = 1,
  Farmacia = 2,
  Ortopedia = 3,
}

const TITULOS: Record<TipoGastoEnum, string> = {
  [TipoGastoEnum.Transporte]: 'Solicitud de Abono de Gastos de Transporte',
  [TipoGastoEnum.Farmacia]: 'Solicitud de Abono de Gastos de Farmacia',
  [TipoGastoEnum.Ortopedia]: 'Solicitud de Abono de Gastos de Ortopedia',
}

const HistorialSolicitudGastosContingenciaProfesional: React.FC = () => {
  const navigate = useNavigate()
  const { idprestacion, idform } = useParams()

  const [userId, setUserId] = useState('')
  const [prestacionId, setPrestacionId] = useState('')
  const [formId, setFormId] = useState('')
  const [loading, setLoading] = useState(true)

  const {
    dataGetSolicitudGastosContingenciaProfesionalById,
    loadingGetSolicitudGastosContingenciaProfesionalById,
    getSolicitudGastosContingenciaProfesionalById
  } = useGetSolicitudGastosContingenciaProfesionalItByID()

  // 1. Cargar IDs iniciales
  useEffect(() => {
    const decoded = useDecode("token")
    const presId = idprestacion.split('_')[1]

    setUserId(decoded.extension_id)
    setPrestacionId(presId)
    setFormId(idform)
  }, [idprestacion, idform])

  useEffect(() => {
    if (!userId || !prestacionId || !formId) return

    getSolicitudGastosContingenciaProfesionalById(userId, prestacionId, formId)

    setTimeout(() => setLoading(false), 1500)
  }, [userId, prestacionId, formId])
  const tipoReal = dataGetSolicitudGastosContingenciaProfesionalById?.TipoGasto as TipoGastoEnum | undefined
  const title = tipoReal ? TITULOS[tipoReal] : "Cargando..."

  return (
    <div>
      <PageMenu title={title}>
        <div className="btns-header-container">
          <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
            <img src={IconArrowGray} alt="" />
          </button>
        </div>
      </PageMenu>

      <Loader
        activeLoader={loading || loadingGetSolicitudGastosContingenciaProfesionalById}
        label="Cargando Formulario"
      />

      {
        tipoReal && !loading && !loadingGetSolicitudGastosContingenciaProfesionalById && (
          <SolicitudGastosContingenciaProfesional
            info={false}
            prestacionId={prestacionId}
            userId={userId}
            formId={formId}
            tipoGasto={tipoReal}  
          />
        )
      }
    </div>
  )
}

export default HistorialSolicitudGastosContingenciaProfesional
